import { Vessel } from './vessel';

export interface VesselsStoreState {
  readonly vessels: Vessel[];
  readonly isFetchingVessels: boolean;
  readonly fetchError: string | undefined;
}

export const INITIAL_VESSELS_STORE_STATE: VesselsStoreState = {
  vessels: new Array<Vessel>(),
  isFetchingVessels: false,
  fetchError: undefined,
};
